import React, { useEffect, useState } from "react";
import "./LoanTypes.scss";
import { 
    Box, 
    Typography, 
    Button,
    Tab,
    Tabs
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { commonRunQuery, loansCreateLoanType, loansUpdateLoanType, loansUpdateLoanTypeLangIds } from "../../../util/API/loans";
import EditIcon from "../../../images/editpencil.svg";
import CustomLoansForm from "../../../components/UI/CustomLoansForm/CustomLoansForm";
import LoanSetupTable from "../../../components/LoanSetupTable/LoanSetupTable";
import { useDispatch } from "react-redux";
import { setNewConstants } from "../../../store/redux/constants";
import LoanTypesDetailsView from "../../../components/LoanTypesDetailsView/LoanTypesDetailsView";
import LoanLangTagsTable from "../../../components/LoanLangTagsTable/LoanLangTagsTable";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                backgroundColor: "white",
            }}
            
        >
            {value === index && (
            <Box sx={{ p: 3 }} className="loans-setup-custom-tab-container">
               {children}
            </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
}

const LoanTypes = ({setAlert, setAlertOpen}) => {
    const [loanTypes, setLoanTypes] = useState([]);
    const [formattedLoanTypes, setFormattedLoanTypes] = useState([]);
    const [formValues, setFormValues] = useState(null);
    // const [createLoanType, setCreateLoanType] = useState(false);
    const [loanProductsArr, setLoanProductsArr] = useState([]);
    const [value, setValue] = useState(0);
    const [viewDetails, setViewDetails] = useState(false);
    const [loanTypeConfig, setLoanTypeConfig] = useState({});
    const [loanTypeMsgTexts, setLoanTypeMsgTexts] = useState({});
    const [viewMode, setViewMode] = useState("table");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [langIDData, setLangIDData] = useState(null);
    const [feeTableData, setFeeTableData] = useState([]);
    const [langIdTableData, setLangIdTableData] = useState([]);
    const [selectedLangId, setSelectedLangId] = useState(null);
    
    const dispatch = useDispatch();

    useEffect(()=> {
        getAllLoanTypes();
        getAllLoanProducts();
        getFeeTableData();
    }, []);

    useEffect(()=> {
        dispatch(setNewConstants({ formSelectData: { productid: loanProductsArr, purchasetableid: feeTableData, latefeetableid: feeTableData, nextloantype:formattedLoanTypes } }));
    },[loanProductsArr, feeTableData, formattedLoanTypes])

    // useEffect(()=> {
    //     if(viewMode == "createlangid") {
    //         console.log("formattedLoanTypes-------",formattedLoanTypes)
    //         dispatch(setNewConstants({ formSelectData: { loantype: formattedLoanTypes } }));
    //     }
    // },[viewMode])

    const getAllLoanTypes = async() => {
        try {
            const response = await commonRunQuery(269,"");
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanTypesArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setLoanTypes(loanTypesArray);
            } else {
                setLoanTypes([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const getAllLoanProducts = async () => {
        try {
            let response = await commonRunQuery(268, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const loanProductsArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedLoanProducts = loanProductsArray.map(item => ({
                    key: item.lp.productid,
                    value: item.lp.productid,
                    label: item.lp.name,
                }));
    
                setLoanProductsArr(formattedLoanProducts);
                console.log("formattedLoanProducts=======================", formattedLoanProducts);
            } else {
                setLoanProductsArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    };

    const getFeeTableData = async () => {
        try {
            let response = await commonRunQuery(273, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const feeDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedFeesDataArr = feeDataArray.map(item => ({
                    key: item.purchasefeetable?.tableid,
                    value: item.purchasefeetable?.tableid,
                    label: item.purchasefeetable?.description,
                }));
    
                setFeeTableData(formattedFeesDataArr);
                console.log("formattedFeesDataArr=======================", formattedFeesDataArr);
            } else {
                setFeeTableData([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    }

    const handleSubmit = (submittedValue) => {
        console.log("Submitted Data================", submittedValue);
    }

    const handleLoanTypeCreate = async(submittedValue) => {
        console.log("Submitted Dataaaaaa================", submittedValue);
        try {
            const response = await loansCreateLoanType(
                submittedValue?.location,
                submittedValue?.timegranularity,
                submittedValue?.terminterestallocationtype,
                submittedValue?.stopcalculatingafterdays,
                submittedValue?.selectablebyuser,
                submittedValue?.restrictive,
                submittedValue?.purchasetableid,
                submittedValue?.productid,
                submittedValue?.optout,
                submittedValue?.optin,
                submittedValue?.numberofdays,
                submittedValue?.noofduedays,
                submittedValue?.nextloantype,
                submittedValue?.maxactiveloans,
                submittedValue?.loandesc,
                submittedValue?.latefeetableid,
                submittedValue?.isflaggedloandue,
                submittedValue?.includefeesineligibilitycheck,
                submittedValue?.ignorenextbusinessday,
                submittedValue?.ignoreholidays,
                submittedValue?.graceperioddays,
                submittedValue?.flaggingwaringdays,
                submittedValue?.flaggingdays,
                submittedValue?.flagging,
                0.00,
                0.00,
                0.00,
                submittedValue?.feecalculationmode,
                0,
                submittedValue?.disbursementtype,
                submittedValue?.unblocklangid,
                submittedValue?.optoutlangid,
                submittedValue?.optinlangid,
                submittedValue?.noteligiblelangid,
                submittedValue?.nexttierwarninglangid,
                submittedValue?.nexttiernotificationlangid,
                submittedValue?.loanrequestwarninglangid,
                submittedValue?.loanrequestconfirmationlangid,
                submittedValue?.loanpaymentconfirmationlangid,
                submittedValue?.loanlimitlangid,
                submittedValue?.latefeewarninglangid,
                submittedValue?.latefeelangid,
                submittedValue?.flagwarninglangid,
                submittedValue?.flaggedlangid,
                submittedValue?.blockedlangid
            );

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan type created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanTypes();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating loan type. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleLoanTypeUpdate = async(submittedValue) => {
        console.log("handleLoanTypeUpdate_Submitted Dataaaaaa================", submittedValue?.loantype);
        try {
            const response = await loansUpdateLoanType(
                submittedValue?.location,
                submittedValue?.loantype,
                submittedValue?.timegranularity,
                submittedValue?.terminterestallocationtype,
                submittedValue?.stopcalculatingafterdays,
                submittedValue?.selectablebyuser,
                submittedValue?.restrictive,
                submittedValue?.purchasetableid,
                submittedValue?.productid,
                submittedValue?.optout,
                submittedValue?.optin,
                submittedValue?.numberofdays,
                submittedValue?.noofduedays,
                submittedValue?.nextloantype,
                submittedValue?.maxactiveloans,
                submittedValue?.loandesc,
                submittedValue?.latefeetableid,
                submittedValue?.isflaggedloandue,
                submittedValue?.includefeesineligibilitycheck,
                submittedValue?.ignorenextbusinessday,
                submittedValue?.ignoreholidays,
                submittedValue?.graceperioddays,
                submittedValue?.flaggingwaringdays,
                submittedValue?.flaggingdays,
                submittedValue?.flagging,
                0.00,
                0.00,
                0.00,
                submittedValue?.feecalculationmode,
                0,
                submittedValue?.disbursementtype,
                submittedValue?.unblocklangid,
                submittedValue?.optoutlangid,
                submittedValue?.optinlangid,
                submittedValue?.noteligiblelangid,
                submittedValue?.nexttierwarninglangid,
                submittedValue?.nexttiernotificationlangid,
                submittedValue?.loanrequestwarninglangid,
                submittedValue?.loanrequestconfirmationlangid,
                submittedValue?.loanpaymentconfirmationlangid,
                submittedValue?.loanlimitlangid,
                submittedValue?.latefeewarninglangid,
                submittedValue?.latefeelangid,
                submittedValue?.flagwarninglangid,
                submittedValue?.flaggedlangid,
                submittedValue?.blockedlangid
            );

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan type updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanTypes();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating loan type. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleLangIdCreate = async(submittedValue) => {
        console.log("submittedValue------------------",submittedValue);
        try {
            const response = await loansUpdateLoanTypeLangIds(
                "",
                submittedValue?.loantype,
                submittedValue?.unblocklangid,
                submittedValue?.optoutlangid,
                submittedValue?.optinlangid,
                submittedValue?.noteligiblelangid,
                submittedValue?.nexttierwarninglangid,
                submittedValue?.nexttiernotificationlangid,
                submittedValue?.loanrequestwarninglangid,
                submittedValue?.loanrequestconfirmationlangid,
                submittedValue?.loanpaymentconfirmationlangid,
                submittedValue?.loanlimitlangid,
                submittedValue?.latefeewarninglangid,
                submittedValue?.latefeelangid,
                submittedValue?.flagwarninglangid,
                submittedValue?.flaggedlangid,
                submittedValue?.blockedlangid
            );

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan type lang ids updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanTypes();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating loan type lang ids. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const columns = [
        {
            label: 'Type Id',
            getValue: (row) => row?.loantypes?.loantype ?? ''
        },
        {
            label: 'Description',
            getValue: (row) => row?.loantypes?.loandesc?.toString().trim() ? row?.loantypes?.loandesc : "-"
        },
        {
            label: 'Flagging',
            getValue: (row) => row?.loantypes?.flagging == 1 ? 'Yes' : 'No'
        },
        {
            label: 'Flagging Days',
            getValue: (row) => row?.loantypes?.flaggingdays ?? ''
        },
        {
            label: 'Next Loan Type',
            getValue: (row) => row?.loantypes?.nextloantype === "0" ? "None" : row?.loantypes?.nextloantype ?? "None"
        },
        {
            label: 'Grace Period Days',
            getValue: (row) => row?.loantypes?.graceperioddays ?? ''
        },
    ];

    const handleChange = (event, newValue) => {
        console.log("newValue---------",newValue)
        setValue(newValue);
    };

    const TIME_GRANULARITY_MAP = {
        "0": "End of Day Calculation",
        "1": "24 Hours Calculation",
    };
    
    const TERM_INTEREST_ALLOCATION_MAP = {
        "0": "Diminishing Allocation",
        "1": "Flat Allocation",
        "2": "Flat Principal",
    };
    
    const FEE_CALCULATION_MODE_MAP = {
        "1": "Original Principal",
        "2": "Outstanding Principal",
        "3": "Total Outstanding",
    };
    
    const DISBURSEMENT_TYPE_MAP = {
        "1": "Full Principal",
        "2": "Principal - Interest",
    };

    const transformLoanTypeConfig = (recordData) => {
        if (!recordData) return {};
      
        const { lt, pft1, pft2, nxt, record  } = recordData;
      
        return {
          // 🔝 Move these to top (keys unchanged)
          LoanType: lt.LoanType,
          LoanDescription: lt.LoanDescription,
      
          // 🔁 Replace IDs with descriptions (same key name)
          PurchaseTableId: pft1?.PurchaseTableDescription ?? lt.PurchaseTableId,
          LateFeeTableId: pft2?.LateFeeTableDescription ?? lt.LateFeeTableId,
      
          TermInterestAllocationType:
            TERM_INTEREST_ALLOCATION_MAP[lt.TermInterestAllocationType] ??
            lt.TermInterestAllocationType,

          // 🔄 Translated enum values (same keys)
          TimeGranularity:
            TIME_GRANULARITY_MAP[lt.TimeGranularity] ?? lt.TimeGranularity,
      
          // 📦 Rest of the fields unchanged
          DisplayOrderNumber: lt.DisplayOrderNumber,
          FeeFixed: lt.FeeFixed,
          FeePercentage: lt.FeePercentage,
          FeeTax: lt.FeeTax,
          Flagging: lt.Flagging,
          FlaggingDays: lt.FlaggingDays,
          FlaggingWarningDays: lt.FlaggingWarningDays,
          GracePeriodDays: lt.GracePeriodDays,
          IgnoreHolidays: lt.IgnoreHolidays,
          IgnoreNextBusinessDay: lt.IgnoreNextBusinessDay,
          IncludeFeesInEligibilityCheck: lt.IncludeFeesInEligibilityCheck,
          IsFlaggedLoanDue: lt.IsFlaggedLoanDue,
          MaxActiveLoans: lt.MaxActiveLoans,
          NextLoanType: nxt.NextLoanDescription ? nxt.NextLoanDescription : 'N/A',
        //   NextLoanType: lt.NextLoanType,
          NumberOfDays: lt.NumberOfDays,
          NumberOfDueDays: lt.NumberOfDueDays,
          OptIn: lt.OptIn,
          OptOut: lt.OptOut,
          ProductId: lt.ProductId,
          Restrictive: lt.Restrictive,
          SelectableByUser: lt.SelectableByUser,
          FeeCalculationMode:
            FEE_CALCULATION_MODE_MAP[lt.FeeCalculationMode] ??
            lt.FeeCalculationMode,
          StopCalculatingAfterDays: lt.StopCalculatingAfterDays,
          DisbursementType:
            DISBURSEMENT_TYPE_MAP[lt.DisbursementType] ??
            lt.DisbursementType,
          PaymentTerm: record ? record?.PlanDescriptions : 'N/a',
          structuredData: value
        //   lt,
        //   pft1,
        //   pft2,
        };
    };

    const handleViewDetails = async(rowData) => {
        console.log("rowData=======================",rowData?.loantypes?.loantype);
        setViewMode("view")
        try {
            const response = await commonRunQuery(271,rowData?.loantypes?.loantype);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                // const loanTypesConfigArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];

                const transformedData = transformLoanTypeConfig(
                    response?.data?.body?.record
                );
                
                console.log("untransformedData=======================",response?.data?.body?.record);
                console.log("transformedData=======================",transformedData);

                setLoanTypeConfig(transformedData);
                // setLoanTypeConfig(response?.data?.body?.record);
                console.log("loanTypesConfigArray=======================",response?.data?.body?.record);
            } else {
                setLoanTypeConfig({});
            }

            const response2 = await commonRunQuery(270,rowData?.loantypes?.loantype);
            if ( response2?.data?.header?.callStatus === "1" && response2?.data?.header?.reccount !== "0" ) {
                // const loanTypesMsgTextsArray = Array.isArray(response2?.data?.body?.record) ? response2?.data?.body?.record : [response2?.data?.body?.record];
                setLoanTypeMsgTexts(response2?.data?.body?.record?.loantypes);
                console.log("loanTypesMsgTextsArray=======================",response2?.data?.body?.record?.loantypes);
            } else {
                setLoanTypeMsgTexts({});
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const handleEdit = (rowData) => {
        console.log("rowData--------------",rowData);
        setSelectedProduct(rowData);

        if(loanTypes.length>0) {
            const formattedLoanTypes = loanTypes
            .filter(item => item.loantypes.loantype !== rowData?.loantypes?.loantype)
            .map(item => ({
                key: item.loantypes.loantype,
                value: item.loantypes.loantype,
                label: item.loantypes.loandesc,
            }));

            setFormattedLoanTypes(formattedLoanTypes);
            console.log("formattedLoanTypes=======================",formattedLoanTypes);
        }
        
        setViewMode("edit");
    };

    const handleLoanTypeChange = async(submittedValue) => {
        console.log("handleLoanTypeChange--------------",submittedValue);
        try {
            const response = await commonRunQuery(270,submittedValue);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                // const loanTypesMsgTextsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setLoanTypeMsgTexts(response?.data?.body?.record?.loantypes);
                console.log("loanTypesMsgTextsArray=======================",response?.data?.body?.record?.loantypes);
                setLangIDData(response?.data?.body?.record?.loantypes);
            } else {
                setLoanTypeMsgTexts({});
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const handleLangIdSelect = async(langIdData) => {
        console.log("langIdData=======================",langIdData);
        setViewMode("viewLangIdTable");
        setSelectedLangId(langIdData);
        try {
            const response = await commonRunQuery(275,langIdData);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const langIdDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
                setLangIdTableData(langIdDataArray);
                console.log("langIdDataArray=======================",langIdDataArray);
            } else {
                setLangIdTableData([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    return (
        <Box sx={{ p: 3 }} className="loan-types-container">
            <Box className="d-flex justify-content-between mb-2">
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                >
                    {viewMode == "viewLangIdTable" ? "Language Tags" : "Loan Types"}
                </Typography>
                {
                    viewMode !== "table" && viewMode !== "viewLangIdTable"  ?
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table")
                                setValue(0);
                            }}
                        >
                            Return
                        </Button>
                        :
                        null
                        // <Box className="d-flex gap-2">
                        //     <Button
                        //         className="fs-size-12 paiy-blue text-white"
                        //         variant="contained"
                        //         color="primary"
                        //         onClick={() => setViewMode("create")}
                        //     >
                        //         Create Loan Type
                        //     </Button>

                        //     <Button
                        //         className="fs-size-12 paiy-blue text-white"
                        //         variant="contained"
                        //         color="primary"
                        //         disabled={formattedLoanTypes.length > 0 ? false : true}
                        //         onClick={() => setViewMode("createlangid")}
                        //     >
                        //         Create / Update Lang ID's
                        //     </Button>

                        // </Box>
                }
            </Box>
    
            {
                viewMode === "create" ? (
                    <Box>
                        <Box className="batch-tabs">
                            <Box sx={{ width: "100%" }}>
                                <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        TabIndicatorProps={{ style: { display: "none" } }}
                                        sx={{
                                            "& .MuiTab-root": {
                                                textTransform: "capitalize",
                                                color: "#BCBCBC",
                                                fontFamily: "Inter",
                                                fontSize: 15,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "30px",
                                                backgroundColor: "#f8f8f8",
                                                width: "178px",
                                                "&.Mui-selected": {
                                                    backgroundColor: "white",
                                                    color: "#5523D2",
                                                    borderRadius: "6px 6px 0 0 !important",
                                                    textAlign: "center",
                                                    fontSize: 15,
                                                    fontStyle: "normal",
                                                    fontWeight: 600,
                                                    lineHeight: "30px",
                                                    borderBottom: 0,
                                                    borderBottomColor: "#FAC800",
                                                    borderBottomWidth: 4,
                                                },
                                            },
                                        }}
                                    >
                                        <Tab label="Configuration" {...a11yProps(0)} />
                                        {/* <Tab label="Message Texts" {...a11yProps(1)} /> */}
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={value} index={0}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypes"}
                                            buttonText={"Submit"}
                                            onSubmit={handleLoanTypeCreate}
                                            loadingButtonText={"Creating Loan Type ..."}
                                            isCreate={true}
                                        />
                                    </Box>
                                </CustomTabPanel>
                                {/* <CustomTabPanel value={value} index={1}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypemessagetexts"}
                                            buttonText={"Submit"}
                                            onSubmit={handleSubmit}
                                            loadingButtonText={"Creating Loan Type ..."}
                                            isCreate={true}
                                        />
                                    </Box>
                                </CustomTabPanel> */}
                            </Box>
                        </Box>
                    </Box>
                ) : viewMode === "createlangid" ? (
                    <Box>
                        <Box className="batch-tabs">
                            <Box sx={{ width: "100%" }}>
                                <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        TabIndicatorProps={{ style: { display: "none" } }}
                                        sx={{
                                            "& .MuiTab-root": {
                                                textTransform: "capitalize",
                                                color: "#BCBCBC",
                                                fontFamily: "Inter",
                                                fontSize: 15,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "30px",
                                                backgroundColor: "#f8f8f8",
                                                width: "178px",
                                                "&.Mui-selected": {
                                                    backgroundColor: "white",
                                                    color: "#5523D2",
                                                    borderRadius: "6px 6px 0 0 !important",
                                                    textAlign: "center",
                                                    fontSize: 15,
                                                    fontStyle: "normal",
                                                    fontWeight: 600,
                                                    lineHeight: "30px",
                                                    borderBottom: 0,
                                                    borderBottomColor: "#FAC800",
                                                    borderBottomWidth: 4,
                                                },
                                            },
                                        }}
                                    >
                                        <Tab label="Message Texts" {...a11yProps(0)} />
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={value} index={0}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypemessagetexts"}
                                            buttonText={"Submit"}
                                            onSubmit={handleLangIdCreate}
                                            loadingButtonText={"Creating Loan Type ..."}
                                            isCreate={false}
                                            initialValues={langIDData}
                                            handleLoanTypeChange={handleLoanTypeChange}
                                        />
                                    </Box>
                                </CustomTabPanel>
                            </Box>
                        </Box>
                    </Box>
                ) : viewMode === "view" ? (
                    <Box>
                        <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                TabIndicatorProps={{ style: { display: "none" } }}
                                sx={{
                                    "& .MuiTab-root": {
                                        textTransform: "capitalize",
                                        color: "#BCBCBC",
                                        fontFamily: "Inter",
                                        fontSize: 15,
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "30px",
                                        backgroundColor: "#f8f8f8",
                                        width: "178px",
                                        "&.Mui-selected": {
                                            backgroundColor: "white",
                                            color: "#5523D2",
                                            borderRadius: "6px 6px 0 0 !important",
                                            textAlign: "center",
                                            fontSize: 15,
                                            fontStyle: "normal",
                                            fontWeight: 600,
                                            lineHeight: "30px",
                                            borderBottom: 0,
                                            borderBottomColor: "#FAC800",
                                            borderBottomWidth: 4,
                                        },
                                    },
                                }}
                            >
                                <Tab label="Configuration" {...a11yProps(0)} />
                                <Tab label="Message Texts" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <LoanTypesDetailsView data={loanTypeConfig} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <LoanTypesDetailsView data={loanTypeMsgTexts} handleLangIdSelect={handleLangIdSelect} />
                        </CustomTabPanel>
                    </Box>
                ) : viewMode === "edit" ? (
                    <Box className="mt-4">
                        <Box className="batch-tabs">
                            <Box sx={{ width: "100%" }}>
                                <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        TabIndicatorProps={{ style: { display: "none" } }}
                                        sx={{
                                            "& .MuiTab-root": {
                                                textTransform: "capitalize",
                                                color: "#BCBCBC",
                                                fontFamily: "Inter",
                                                fontSize: 15,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "30px",
                                                backgroundColor: "#f8f8f8",
                                                width: "178px",
                                                "&.Mui-selected": {
                                                    backgroundColor: "white",
                                                    color: "#5523D2",
                                                    borderRadius: "6px 6px 0 0 !important",
                                                    textAlign: "center",
                                                    fontSize: 15,
                                                    fontStyle: "normal",
                                                    fontWeight: 600,
                                                    lineHeight: "30px",
                                                    borderBottom: 0,
                                                    borderBottomColor: "#FAC800",
                                                    borderBottomWidth: 4,
                                                },
                                            },
                                        }}
                                    >
                                        <Tab label="Configuration" {...a11yProps(0)} />
                                        {/* <Tab label="Message Texts" {...a11yProps(1)} /> */}
                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={value} index={0}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypes"}
                                            buttonText={"Submit"}
                                            onSubmit={handleLoanTypeUpdate}
                                            loadingButtonText={"Creating Loan Type ..."}
                                            initialValues={selectedProduct?.loantypes}
                                            isLoanProduct={true}
                                            isEdit={true}
                                        />
                                    </Box>
                                </CustomTabPanel>
                                {/* <CustomTabPanel value={value} index={1}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypemessagetexts"}
                                            buttonText={"Submit"}
                                            onSubmit={handleSubmit}
                                            loadingButtonText={"Creating Loan Type ..."}
                                            initialValues={selectedProduct?.loantypes}
                                        />
                                    </Box>
                                </CustomTabPanel> */}
                            </Box>
                        </Box>
                    </Box>
                ) : viewMode === "viewLangIdTable" ? (
                    <Box>
                        <Box sx={{ borderRadius: "12px" }}>
                            <LoanLangTagsTable setAlert={setAlert} langIdTableData={langIdTableData} setViewMode={setViewMode} setValue={setValue} selectedLangId={selectedLangId} />
                        </Box>
                    </Box>
                ) : (
                    <Box className="mt-4">
                        <LoanSetupTable
                            data={loanTypes}
                            columns={columns}
                            title="Loan Types"
                            formatRow={(row) => [
                                row?.loantypes?.loantype,
                                row?.loantypes?.loandesc,
                                row?.loantypes?.flagging,
                                row?.loantypes?.flaggingdays,
                                row?.loantypes?.nextloantype,
                                row?.loantypes?.graceperioddays
                            ]}
                            handleEdit={handleEdit}
                            handleViewDetails={handleViewDetails}
                            isEdit={true}
                            viewDetails={true}
                        />
                    </Box>
                )
            }
        </Box>
    );
    
}

export default LoanTypes;